import { render, staticRenderFns } from "./ServiceAdd.vue?vue&type=template&id=bc930ade&scoped=true"
import script from "./ServiceAdd.vue?vue&type=script&lang=js"
export * from "./ServiceAdd.vue?vue&type=script&lang=js"
import style0 from "./ServiceAdd.vue?vue&type=style&index=0&id=bc930ade&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc930ade",
  null
  
)

export default component.exports